import { AdMobBanner } from "expo-ads-admob";
import * as Device from "expo-device";
import React from "react";

const TEST_ID = "ca-app-pub-3940256099942544/6300978111"; // NOTE: テストID (https://developers.google.com/admob/unity/test-ads?hl=ja#sample_ad_units)
const PRODUCTION_ID = "ca-app-pub-7716238237159703/7282541065"; // NOTE: 本物ID (ヨーヨー_バナー)

const adUnitId = Device.isDevice && !__DEV__ ? PRODUCTION_ID : TEST_ID;

export const AD_BANNER_HEIGHT = 50;

// FYI: https://docs.expo.dev/versions/latest/sdk/admob/
export const AdBanner: React.FC = () => {
  if (Device.brand === null) return null; //NOTE: webの場合は非表示 (https://docs.expo.dev/versions/latest/sdk/device/#devicebrand)
  return (
    <AdMobBanner bannerSize="banner" adUnitID={adUnitId} servePersonalizedAds />
  );
};
